<template>
  <transition @enter="enter" @leave="leave">
    <button
      :class="[
        'next',
        inApp ? 'next--app' : '',
      ]"
      v-if="$store.state.currentGame.showNext"
      @click="handlerClick"
    >
      <span class="grid-hide"></span>
      <span class="next__content" v-html="$translate('layout').nextButton" />
      <span class="next__arrow">
        <span class="grid-hide"></span>
        <svg  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 19.2">
          <polygon
            points="97.6,8.3 88.6,0.2 86,2.8 91.5,7.8 1,7.8 1,10.7 92.3,10.7 86,
            16.4 88.6,19 97.6,10.9 99,9.6"
          />
        </svg>
      </span>
    </button>
  </transition>
</template>

<script>
import anime from '@/assets/libs/anime';
import audio from '@/scripts/audio';
import { inApp } from '@/scripts/utils';

export default {
  name: 'GameNextButton',

  data() {
    return {
      inApp: inApp(),
    };
  },

  methods: {
    handlerClick() {
      this.$store.dispatch('next');
      audio.play('next');
    },

    enter(el, done) {
      // const content = el.querySelector('.next__content');
      const arrow = el.querySelector('.next__arrow svg');
      const tl = anime.timeline({
        duration: inApp ? 1000 : 1800,
        delay: inApp ? 700 : 1000,
        easing: 'cubicBezier(.5,0,0,1)',
        complete: done,
      });

      tl
        .add({
          targets: el,
          translateY: ['100%', 0],
          opacity: [0, 1],
        }, 0)
        .add({
          targets: arrow,
          translateX: [-50, 0],
          webkitClipPath: ['inset(0.01% 100% 0.03% 0.04%)', 'inset(0.01% 0.02% 0.03% 0.04%)'],
          clipPath: ['inset(0.01% 100% 0.03% 0.04%)', 'inset(0.01% 0.02% 0.03% 0.04%)'],
        }, 200);

      return tl;
    },

    leave(el, done) {
      anime({
        targets: el,
        translateY: '100%',
        opacity: {
          value: 0,
          duration: 500,
        },
        duration: inApp ? 1000 : 1800,
        easing: 'cubicBezier(.5,0,0,1)',
        complete: done,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.next {
  position: relative;
  display: block;
  width: calc((var(--unit-vw) * 2) - 2px);
  flex: 0 0 calc((var(--unit-vw) * 2) - 2px);
  height: 100%;
  font-size: 14px;
  font-weight: 300;
  // font-style: italic;

  display: flex;
  align-items: center;
  justify-content: space-between;

  & > .grid-hide {
    display: none;
  }

  &:hover {
    .next__content {
      transform: translateX(-6px) skewX(-25deg);
    }

    .next__arrow svg polygon {
      clip-path: inset(0% 0% 0% 10%);
    }
  }

  &__content {
    position: relative;
    width: var(--unit-vw);
    flex: 0 0 var(--unit-vw);

    transition: transform .6s ease;
    transform-origin: 0px 100%;

    @extend %font-size-next;
  }

  &__arrow {
    position: relative;
    display: block;
    width: calc(var(--unit-vw) * 1);
    flex: 0 0 calc(var(--unit-vw) * 1);
    height: calc(var(--unit-vh) - 1px);

    // background-color: $color-bg;

    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 50%;
      fill: $color-black;

      polygon {
        clip-path: inset(0%);
        transition: clip-path .6s ease;
      }
    }
  }

  @include mq($until: ipadP) {
    position: relative;

    &.next--app {
      .grid-hide {
        background-color: $color-red;
      }
      .next__content {
        font-weight: bold;
        color: $color-bg;
      }

      svg {
        fill: $color-bg;
      }
    }

    & > .grid-hide {
      display: block;
    }
  }

  @include mq(ipadP) {
    width: calc(var(--unit-vw) * 3);
    font-size: 18px;

    &__arrow {
      width: calc((var(--unit-vw) * 2) - 2px);
      flex: 0 0 calc((var(--unit-vw) * 2) - 2px);
    }
  }
}
</style>
